<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;">
    <v-row align="start" justify="center" class="px-12">
      <v-col cols="12">
        <v-card class="elevation-5">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>General Account Settings</v-toolbar-title>
          </v-toolbar>

          <v-tabs vertical>
            <v-tab>
              <v-icon left>mdi-account</v-icon>
              <span>Account</span>
            </v-tab>
            <v-tab>
              <v-icon left>mdi-lock</v-icon>
              <span>Security</span>
            </v-tab>
            <v-tab-item>
              <v-card flat>
                <v-container fluid class="ma-2">
                  <v-form @submit.prevent="updateEmail">
                    <div class="title">Account</div>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          label="Username"
                          v-model="username"
                          outlined
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-n6">
                      <v-col cols="12" sm="6">
                        <v-text-field
                          label="Email"
                          outlined
                          v-model="email"
                          :disabled="editAccountBtn"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="mt-n6" v-if="editAccountBtn == true">
                      <v-col cols="12" sm="6">
                        <v-btn
                          color="primary"
                          class="ma-1"
                          @click="editAccountBtn = !editAccountBtn"
                        >
                          <v-icon left>mdi-pencil</v-icon>
                          <span>Edit</span>
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row class="mt-n6" v-else>
                      <v-col cols="12" sm="6">
                        <v-btn
                          color="error"
                          class="ma-1"
                          @click="editAccountBtn = !editAccountBtn"
                        >
                          <v-icon left>mdi-cancel</v-icon>
                          <span>Cancel</span>
                        </v-btn>
                        <v-btn
                          color="success"
                          class="ma-1"
                          type="submit"
                          :loading="updateAccountBtn"
                        >
                          <v-icon left>mdi-check</v-icon>
                          <span>Update</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <v-container fluid class="ma-2">
                  <!-- Change Password -->
                  <v-form @submit.prevent="updatePassword">
                    <div class="title">Change Password</div>

                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="currentPassword"
                          label="Current Password"
                          type="password"
                          autocomplete="off"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="mt-n10">
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="newPassword"
                          label="New Password"
                          type="password"
                          autocomplete="off"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="mt-n10">
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="confirmPassword"
                          label="Confirm Password"
                          type="password"
                          autocomplete="off"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="mt-n10">
                      <v-col cols="12" sm="6">
                        <v-btn
                          color="primary"
                          type="submit"
                          :loading="updatePasswordBtn"
                        >
                          <span>Update Password</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ApiService from '@/services/api.service'

export default {
  name: 'Profile',
  data() {
    return {
      username: '',
      email: '',
      editAccountBtn: true,
      updateAccountBtn: false,
      updatePasswordBtn: false,
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  methods: {
    getAccount() {
      ApiService.get('/Profile')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.username = res.data.respond.username
              this.email = res.data.respond.email
            } else {
              this.$swal('', res.data.error, 'error')
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {})
    },
    updateEmail() {
      this.updateAccountBtn = true
      ApiService.put('/Profile', { email: this.email }).then(res => {
        if (res.data.isauthenticated) {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success')
            this.updateAccountBtn = false
            this.editAccountBtn = true
            this.getAccount()
          } else {
            this.$swal('', res.data.error, 'error')
            this.updateAccountBtn = false
            this.editAccountBtn = true
            this.getAccount()
          }
        } else {
          this.loading = false
          return this.$router.push({ name: 'home' })
        }
      })
    },
    updatePassword() {
      if (
        this.currentPassword === '' ||
        this.newPassword === '' ||
        this.confirmPassword === ''
      ) {
        this.updatePasswordBtn = false
        this.snackbarError = true
        this.$swal('', 'Password field are required.', 'error')
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        this.updatePasswordBtn = false
        this.snackbarError = true
        this.$swal('', 'New passwords do not match.', 'error')
        return
      }
      this.updatePasswordBtn = true

      ApiService.put('/Profile/changepassword', {
        currentpassword: this.currentPassword,
        newpassword: this.newPassword
      })
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.$swal('', res.data.respond, 'success')
              this.updatePasswordBtn = false
              this.currentPassword = ''
              this.newPassword = ''
              this.confirmPassword = ''
            } else {
              this.$swal('', res.data.error, 'error')
              this.updatePasswordBtn = false
              this.currentPassword = ''
              this.newPassword = ''
              this.confirmPassword = ''
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(err => {
          this.$swal('', err.data.error, 'error')
          this.snackbarMessage = err.response.data.message
        })
    }
  },
  created() {
    this.getAccount()
  }
}
</script>
